module.exports = __webpack_public_path__ + "img/kp76hover.05ad2360.png";